<template>
    <div class="participationRate" :id="Id"></div>
</template>

<script>
export default {
    //import引入组件才能使用
    components: {},
    props: ['InjectData', 'Id', 'Title', 'XAxis', 'SeriesDataName', 'ChartType', 'Rotate'],
    data() {
        return {
            UnitName: {
                'totalSignInPercent': '%',
                'errHoldPercent': '%',
                'errSitPercent': '%',
                'NumberOfPeople': '人',
            },
            chartInstance: null,
            resizeHandler: null  // 添加一个属性来保存事件处理函数
        };
    },
    // 计算属性
    computed: {},
    // 监听data中的数据变化
    watch: {
        InjectData: {
            handler() {
                this.Proportion();
            },
            deep: true,
        }
    },

    // 方法集合
    methods: {
        formattedValue(value) {
            //参与情况
            if (this.SeriesDataName == 'totalSignInPercent') {
                return parseFloat(value).toFixed(2)
            } else if (this.SeriesDataName == 'errHoldPercent') {
                return parseFloat(value).toFixed(2)
            } else if (this.SeriesDataName == 'errSitPercent') {
                return parseFloat(value).toFixed(2)
            } else if (this.SeriesDataName == 'NumberOfPeople') {
                return value
            }
            return value;
        },
        Proportion(data) {
            let that = this;
            if (this.chartInstance) {
                this.chartInstance.dispose();
            }
            this.chartInstance = this.$echarts.init(
                document.getElementById(this.Id)
            );
            this.chartInstance.setOption({
                grid: {
                    // top: this.graphicRatio(60),
                    bottom: this.graphicRatio(130),
                    // left: this.graphicRatio(60),
                    // right: this.graphicRatio(40),
                },
                tooltip: {
                    show: true,
                    textStyle: {
                        fontSize: this.graphicRatio(15),
                    },
                },
                calculable: true,
                dataZoom: [
                    {
                        type: 'inside',
                        startValue: 0,
                        endValue: 5,
                    },
                ],
                legend: {
                    icon: 'rect',
                    show: true,
                    bottom: '0%',
                },
                xAxis: [{
                    type: 'category',
                    data: this.InjectData.map(item => {
                        return item[this.XAxis]
                    }),
                    axisTick: {
                        show: false,
                        alignWithLabel: true,
                    },
                    splitLine: {
                        show: false,
                    },
                    axisLabel: {
                        margin: this.graphicRatio(12),
                        fontSize: this.graphicRatio(14),
                        rotate: this.Rotate == 0 ? 0 : -45,  // 添加旋转角度使标签斜着显示
                        interval: 0,  // 确保所有标签都显示，不间隔隐藏
                        formatter: function (value) {
                            // 如果标签长度超过10个字符，截取前10个字符并添加省略号
                            if (value && value.length > 16) {
                                return value.slice(0, 16) + '...';
                            }
                            return value;
                        },
                        overflow: 'truncate',
                        width: 100
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: "#000",
                        }
                    },
                }],
                yAxis: [
                    {
                        type: 'value',
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: "#000",

                            }
                        },
                        axisTick: {
                            show: false
                        },
                        splitLine: {
                            show: false,
                        },
                        axisLabel: {
                            fontSize: this.graphicRatio(14),
                            formatter: that.ChartType == '百分比' ? '{value}%' : '{value}'
                        }
                    },

                ],
                series: [
                    {
                        name: this.Title,
                        type: 'bar',
                        barWidth: this.graphicRatio(35),
                        itemStyle: {
                            borderRadius: [this.graphicRatio(5), this.graphicRatio(5), 0, 0],
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgba(229, 235, 114,0.5)'
                            }, {
                                offset: 1,
                                color: 'rgba(7, 183, 139, 1)'
                            }])
                        },
                        label: {
                            show: true,
                            position: 'top',
                            color: "#000",
                            formatter: (params) => {
                                return `${params.value} ${this.UnitName[this.SeriesDataName]}`;
                            },
                            fontSize: this.graphicRatio(14),
                        },
                        data: this.InjectData.map(item => {
                            //参与情况
                            if (this.SeriesDataName == 'totalSignInPercent') {
                                return parseFloat(item[this.SeriesDataName]).toFixed(2)
                            } else if (this.SeriesDataName == 'errHoldPercent') {
                                return parseFloat(item[this.SeriesDataName]).toFixed(2)
                            } else if (this.SeriesDataName == 'errSitPercent') {
                                return parseFloat(item[this.SeriesDataName]).toFixed(2)
                            } else if (this.SeriesDataName == 'NumberOfPeople') {
                                return item[this.SeriesDataName]
                            }
                        })
                    },

                ]
            })
            this.resizeHandler = () => {
                if (this.chartInstance) {
                    this.chartInstance.resize();
                }
            };
            window.addEventListener("resize", this.resizeHandler);
            // window.addEventListener("resize", () => {
            //     if (this.chartInstance) {
            //         this.chartInstance.resize();
            //     }
            // });
        },
    },
    // 生命周期，创建完成时（可以访问当前this实例）
    created() {

    },
    // 生命周期：挂载完成时（可以访问DOM元素）
    mounted() {
        // this.Proportion();
        if (this.InjectData) {
            this.Proportion();
        }
    },
    updated() {
        // 确保在DOM更新后重新绘制图表
        this.$nextTick(() => {
            if (this.InjectData) {
                this.Proportion();
            }
        });
    },
    beforeDestroy() {
        if (this.chartInstance) {
            this.chartInstance.dispose();
            this.chartInstance = null;
        }

        // 移除resize事件监听器
        // window.removeEventListener("resize", () => {
        //     if (this.chartInstance) {
        //         this.chartInstance.resize();
        //     }
        // });
        if (this.resizeHandler) {
            window.removeEventListener("resize", this.resizeHandler);
        }
    }
}
</script>
<style scoped lang="less">
.participationRate {
    width: 100%;
    height: 100%;
}
</style>